var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-holder"},[_c('div',{staticClass:"text-center"},[_c('img',{staticClass:"mx-auto",attrs:{"src":require("@/assets/images/snapsuite-icon.png"),"alt":"","width":"50"}}),_c('h5',{staticClass:"text-gray-500 text-purple-800 loading-dots"},[_vm._v("Loading, Please wait")])])])
}]

export { render, staticRenderFns }